// Base address for links
const BASE_URL = "https://psides83.github.io/fbce-website-resources/images/";

// global image links
const PRAY_FOR_ME_IMAGE = BASE_URL.concat("pray-for-me.png");
const KINDNESS_IMAGE = BASE_URL.concat("kindness.jpeg");
const PFM_LOGO = BASE_URL.concat("pfm-logo.png");
const PFM_IMAGE = BASE_URL.concat("pray-for-me.png");
const UPWARD_LOGO = BASE_URL.concat("upward-bb-white-logo.png");
const UPWARD_IMAGE = BASE_URL.concat("upward-boys-game.jpeg");
const GNC_LOGO = BASE_URL.concat("gnc-logo.png");
const GNC_IMAGE = BASE_URL.concat("gnc-image.jpg");
const JEREMY_BROWN_IMAGE = BASE_URL.concat("jeremy-brown.jpg");
const ADVENT_3_IMAGE = BASE_URL.concat("advent3.png");

export {
  PRAY_FOR_ME_IMAGE,
  KINDNESS_IMAGE,
  PFM_LOGO,
  PFM_IMAGE,
  UPWARD_LOGO,
  UPWARD_IMAGE,
  GNC_LOGO,
  GNC_IMAGE,
  JEREMY_BROWN_IMAGE,
  ADVENT_3_IMAGE,
};
